type IconProps = React.ComponentProps<'svg'>

export function InfinityIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 7.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9287 0.000976562C18.418 0.00123182 19.5841 0.593755 20.3662 1.51465C21.1346 2.41945 21.5 3.59927 21.5 4.75C21.5 5.90073 21.1346 7.08055 20.3662 7.98535C19.5839 8.90644 18.4175 9.5 16.9277 9.5C15.4397 9.5 14.2021 8.9104 13.125 8.09863C12.2751 7.45811 11.4921 6.65166 10.7471 5.85059C9.05856 7.64533 7.05174 9.5 4.18848 9.5C2.79588 9.49992 1.72069 8.8803 1.01367 7.95508C0.322593 7.05059 0 5.88187 0 4.75C0 3.61813 0.322593 2.44941 1.01367 1.54492C1.72069 0.619703 2.79588 8.10665e-05 4.18848 0C7.05174 0 9.05962 1.85368 10.748 3.64844C11.4928 2.84775 12.2754 2.04161 13.125 1.40137C14.2018 0.589958 15.4394 0.0015025 16.9268 0.000976562L16.9277 0L16.9287 0.000976562ZM4.18848 1.5C3.28906 1.50008 2.64519 1.88064 2.20605 2.45508C1.75101 3.05056 1.5 3.88197 1.5 4.75C1.5 5.61803 1.75101 6.44944 2.20605 7.04492C2.64519 7.61936 3.28906 7.99992 4.18848 8C6.40816 8 8.01534 6.56281 9.72168 4.75C8.01543 2.93718 6.40818 1.5 4.18848 1.5ZM16.9277 1.5C15.8686 1.50026 14.9412 1.9108 14.0283 2.59863C13.2559 3.18073 12.5325 3.93025 11.7715 4.75C12.5324 5.56974 13.255 6.31928 14.0273 6.90137C14.9405 7.58959 15.8683 8 16.9277 8C17.9859 8 18.731 7.59352 19.2227 7.01465C19.7281 6.41949 20 5.59916 20 4.75C20 3.90084 19.7281 3.08051 19.2227 2.48535C18.731 1.90648 17.9859 1.5 16.9277 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
